import { render, staticRenderFns } from "./MyPurchased.vue?vue&type=template&id=5e62d08d&scoped=true"
import script from "./MyPurchased.vue?vue&type=script&lang=js"
export * from "./MyPurchased.vue?vue&type=script&lang=js"
import style0 from "./MyPurchased.vue?vue&type=style&index=0&id=5e62d08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e62d08d",
  null
  
)

export default component.exports